import { useFormValidatedValue } from 'modules/taboola-common-frontend-modules/validations';
import { useSpendingLimitValidations } from './useSpendingLimitValidations';

export const useFormSpendingLimitValidatedValue = (type, data) => {
    const validations = useSpendingLimitValidations(type, data);
    return useFormValidatedValue(validations);
};
